import Cookies from "js-cookie";

import { SESSION_COOKIE_SECRET, DEBUG } from "../../config";

//
// Types
// ------------------------------------------------------------------

export type AuthState = {
  authenticated: boolean,
  user?: AppUser
}; 

//
// Actions
// ------------------------------------------------------------------

export const AUTHENTICATE = "auth/AUTHENTICATE";
export const SET_CURRENT_USER = "auth/SET_CURRENT_USER";

//
// Helpers
// ------------------------------------------------------------------


// export const setCurrentUser = (user: AppUser) => dispatch =>
//   new Promise(resolve => {
//     if (DEBUG) {
//       console.log("[P] Server - Reducers - Auth: Set current user to", user);
//     }

//     dispatch({
//       type: SET_CURRENT_USER,
//       payload: user
//     });

//     if (user) {
//       Cookies.set(SESSION_COOKIE_SECRET, JSON.stringify(user));
//       dispatch({
//         type: AUTHENTICATE,
//         payload: true
//       });
//     } else {
//       Cookies.remove(SESSION_COOKIE_SECRET);
//       dispatch({
//         type: AUTHENTICATE,
//         payload: false
//       });
//     }

//     resolve(user);
//   });

export const setCurrentUser = (user: AppUser) => dispatch =>
  new Promise(resolve => {
    if (DEBUG) {
      console.log("[P] Server - Reducers - Auth: Set current user to", user);
    }

    dispatch({
      type: SET_CURRENT_USER,
      payload: user
    });

    Cookies.set(SESSION_COOKIE_SECRET, JSON.stringify(user));

    dispatch({
      type: AUTHENTICATE,
      payload: true
    });

    resolve(user);
  });


export const establishCurrentUser = () => dispatch =>
  new Promise(resolve => {
    // First try to get user from cookie
    let cookieValue = Cookies.get(SESSION_COOKIE_SECRET);
    let userFromCookie = cookieValue ? JSON.parse(cookieValue) : null;

    if (userFromCookie) {
      if (DEBUG) {
        console.log(
          "[P] Server - Reducers - Auth: User found in cookie",
          userFromCookie
        );
      }
      dispatch(setCurrentUser(userFromCookie));
      resolve(userFromCookie);
      return;
    }

    // If no user in cookie, get the current user from the server
    fetch('/api/shared/get-current-user', { credentials: 'include' })
      .then(response => response.json())
      .then(data => {
        if (data.authenticated && data.user) {
          if (DEBUG) {
            console.log("[P] Server - Reducers - Auth: User authenticated via API", data.user);
          }

          dispatch(setCurrentUser(data.user));
          resolve(data.user);
        } else {
          if (DEBUG) {
            console.log("[P] Server - Reducers - Auth: User not authenticated");
          }
          resolve({});
        }
      })
      .catch(error => {
        console.error("Error checking authentication:", error);
        resolve({});
      });
  });



export const logoutUser = () => dispatch =>

  new Promise(resolve => {
    if (DEBUG) {
      console.log("[P] Server - Reducers - Auth: Logout user");
    }

    // Call server-side logout to destroy session
    fetch('/api/auth/logout', { method: 'POST', credentials: 'include' }) 
      .finally(() => {
        Cookies.remove(SESSION_COOKIE_SECRET);

        dispatch({
          type: AUTHENTICATE,
          payload: false
        });

        dispatch({
          type: SET_CURRENT_USER,
          payload: undefined
        });

        resolve(undefined);
      });
  });

//
// Reducer
// ------------------------------------------------------------------

const initialState: AuthState = {
  authenticated: false,
  user: undefined
};

const authReducer = (state = initialState, action) => {
  if (DEBUG) {
    // console.log('[P] Server - Reducers - Auth reducer: Action', action);
  }

  switch (action.type) {
    case AUTHENTICATE:
      return {
        ...state,
        authenticated: action.payload
      };

    case SET_CURRENT_USER:
      return {
        ...state,
        user: action.payload
      };

    default:
      return state;
  }
};

export default authReducer;
